import { useQuery } from '@tanstack/react-query'
import { fetchNation } from '@/services/nations'

export function useNation(id: string | undefined) {
  const nationQuery = useQuery({
    queryKey: ['nation', id],
    queryFn: () => fetchNation(id!),
    enabled: !!id,
  })

  return {
    nation: nationQuery.data,
    isLoading: nationQuery.isLoading,
    error: nationQuery.error,
  }
}
